import React from "react";

function HomeCopyright() {
    return (
        <>
            <div className="section section-home-copyright">
                Copyright © 2016-2023 GovAssist, LLC All Rights Reserved
            </div>
        </>
    )
}

export default HomeCopyright;
